import { ComponentChildren, h } from "preact"
import { Category } from "./types"

/*
 * @group Components
 */
export interface KeywordInCategoryProps {
    /**
     * Category suggestion.
     */
    category: Category
    /**
     * Keyword content component to enhance with category suggestion.
     */
    children: ComponentChildren
}

/**
 * Default component for rendering keyword with category suggestion.
 *
 * @group Components
 */
export function KeywordInCategory({ category, children }: KeywordInCategoryProps) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
